import {
  GET_TITLES_LOADING,
  GET_TITLES_SUCCESS,
  GET_TITLES_FAILURE,
} from "redux/types";

const initialState = {
  titlesLoading: false,
  titles: null,
  errors: null,
};

export const getTitlesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_TITLES_LOADING:
      return { ...state, titlesLoading: action.payload };
    case GET_TITLES_SUCCESS:
      return { ...state, titles: action.payload };
    case GET_TITLES_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
